// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { base as _base } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the base chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 8453
 * Chain Name: Base
 * Default Block Explorer: https://basescan.org
 * Default RPC URL: https://mainnet.base.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { base } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: base,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const base = createCommon({
	..._base,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
